import { useRef } from 'react'
import { Armchair, BedDouble, Car, Clock, Coffee, Smile, TreePalm, Tv, Wifi } from 'lucide-react'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import SectionHeading from '@/components/SectionHeading'
import { useGSAP } from '@/lib/gsap'
import { setupReveals } from '@/lib/reveal'

const services = [
  {
    icon: Wifi,
    title: 'Wi-Fi Grátis',
    description: 'Acesso à internet de alta velocidade em todo o hotel para sua comodidade.',
  },
  {
    icon: Car,
    title: 'Estacionamento',
    description: 'Estacionamento coberto com vagas ilimitadas por quarto para sua tranquilidade.',
  },
  {
    icon: Coffee,
    title: 'Café da Manhã',
    description: 'Café da manhã disponível para começar o dia com energia e sabor.',
  },
  {
    icon: BedDouble,
    title: 'Serviço de Quarto',
    description: 'Serviço de quarto disponível para tornar sua estadia ainda mais confortável.',
  },
  {
    icon: Tv,
    title: 'Televisão',
    description: 'Televisão em todos os quartos para seu entretenimento e lazer.',
  },
  {
    icon: TreePalm,
    title: 'Espaço Externo',
    description: 'Espaço externo de convivência, ideal para relaxar ao ar livre durante a sua estadia.',
  },
  {
    icon: Armchair,
    title: 'Cadeira de Massagem',
    description: 'Poltrona de massagem disponível na área interna do hotel para o seu relaxamento.',
  },
  {
    icon: Smile,
    title: 'Atendimento Especial',
    description:
      'Acreditamos que o atendimento faz toda a diferença. Nossa equipe está sempre pronta para atender suas necessidades.',
  },
  {
    icon: Clock,
    title: 'Recepção 24 horas',
    description: 'Recepção 24 horas disponível para atender suas necessidades a qualquer momento.',
  },
]

const Services = () => {
  const root = useRef(null)
  useGSAP(() => setupReveals(root.current), { scope: root })

  return (
    <div ref={root} className="py-20 md:py-24">
      <div className="container-page flex flex-col gap-14">
        <SectionHeading
          as="h1"
          eyebrow="Comodidades"
          title="Nossos serviços"
          description="Oferecemos serviços essenciais para garantir uma estadia confortável e agradável, tudo pensado para sua comodidade e satisfação."
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map(({ icon: Icon, title, description }) => (
            <Card
              key={title}
              data-reveal
              className="transition-[translate,box-shadow] duration-300 [--card-spacing:--spacing(6)] hover:-translate-y-1 hover:shadow-xl hover:shadow-ink/10"
            >
              <CardHeader className="gap-3">
                <span className="mb-2 flex size-12 items-center justify-center rounded-xl bg-secondary text-primary">
                  <Icon className="size-6" />
                </span>
                <CardTitle className="text-xl font-bold">{title}</CardTitle>
                <CardDescription className="leading-relaxed">{description}</CardDescription>
              </CardHeader>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Services
